import type { RealEstateEnrichmentRequest, RealEstateEnrichmentResponse } from "@features/real-estate/types";

type APIError = Error & {
  status?: number;
};

async function requestJSON<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    let message = `${response.status} ${response.statusText}`;
    try {
      const body = await response.json() as { error?: string; message?: string; };
      if (body.error) {
        message = body.error;
      } else if (body.message) {
        message = body.message;
      }
    } catch {
      // fall through to status text
    }
    const error = new Error(message) as APIError;
    error.status = response.status;
    throw error;
  }
  return response.json() as Promise<T>;
}

export async function enrichRealEstate(payload: RealEstateEnrichmentRequest): Promise<RealEstateEnrichmentResponse> {
  return requestJSON<RealEstateEnrichmentResponse>("/api/real-estate/enrich", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
